import React, { useContext, useState, Fragment } from 'react';
import Input from '../components/bronson/Input';
import Button from '../components/bronson/Button';
import Traductor from '../components/Traductor';
import UserService from '../services/UserService';
import ParseService from '../services/ParseService'; //Aumentado por caso redireccion a home
import Loading from '../components/bronson/Loading';
import ToastNotification from '../components/bronson/ToastNotification';
import { withCookies } from 'react-cookie';
import { UserContext } from '../contexts/UserContext';
import Globals from '../Globals';
import { delegate } from 'tippy.js';
import 'tippy.js/themes/light.css';
//CSS
import '../components/css/profile.css';

function PasswordModule({ history, cookies, IsResetPasswordEmail }) {
    const utils = require('../Functions');

    const t = new Traductor();
    const {
        setLogged,
        setUser,
        setBuyerType,
        sethasTransportAvailable,
    } = useContext(UserContext);
    const [PassworduserDatas, SetPassworduserDatas] = useState({
        CurrentPassword: '',
        NewPassword: '',
        RepeatNewPassword: '',
        IsResetPasswordEmail: IsResetPasswordEmail,
    });
    const [showToast, setShowToast] = useState({});
    const [loading, setLoading] = useState(false);

    const [
        InitCurrentPasswordErrorBackend,
        SetInitCurrentPasswordErrorBackend,
    ] = useState('');

    const [errors, setErrors] = useState({
        CurrentPasswordError: '',
        NewPasswordError: '',
        RepeatNewPasswordError: '',
    });

    let optionsInputActualPassword = {
        id: 'my-profile-actual-password',
        type: 'password',
        name: 'CurrentPassword',
        className:
            errors.CurrentPasswordError || InitCurrentPasswordErrorBackend != ''
                ? 'is-error'
                : '',
        label: t.getTraduction('PasswordActual'),
        backButton: {
            type: 'control-eye',
        },
    };

    let optionsInputPassword = {
        id: 'my-profile-password',
        type: 'password',
        name: 'NewPassword',
        className: errors.NewPasswordError ? 'is-error' : '',
        label: t.getTraduction('PasswordNew'),
        backButton: {
            type: 'control-eye',
        },
    };

    let optionsInputRepeatPassword = {
        id: 'my-profile-password-repeat',
        type: 'password',
        name: 'RepeatNewPassword',
        className: errors.RepeatNewPasswordError ? 'is-error' : '',
        label: t.getTraduction('PasswordNewRepeat'),
        backButton: {
            type: 'control-eye',
        },
    };

    let optionsBtn = {
        text: t.getTraduction('ResetPasswordProfile'),
        value: 'guardar',
        type: 'button',
    };

    const onChange = (e, name) => {
        SetInitCurrentPasswordErrorBackend('');
        PutEmptyErrors(name, e);
        SetPassworduserDatas(currentData => ({ ...currentData, [name]: e }));
    };

    function PutEmptyErrors(name, value) {
        if (name === 'CurrentPassword' && value !== '') {
            errors.CurrentPasswordError = '';
        }
        if (name === 'NewPassword' && value !== '') {
            errors.NewPasswordError = '';
        }
        if (name === 'RepeatNewPassword' && value !== '') {
            errors.RepeatNewPasswordError = '';
        }
    }

    const redirectToHome = async res => {
        const cookieJWT = res.Token;
        let tomorrow = new Date();
        tomorrow.setDate(
            tomorrow.getDate() + parseInt(process.env.REACT_APP_JWT_EXPIRES, 10)
        );
        let cookieOptions = {
            path: process.env.PUBLIC_URL,
            expires: tomorrow,
            maxAge: parseInt(process.env.REACT_APP_JWT_MAXAGE, 10),
        };

        let usuarioResponse = await new UserService().getUser(
            cookieJWT.AccessToken
        );
        if (usuarioResponse && usuarioResponse.statusCode == 200) {
            let usuario = new ParseService().Parse(usuarioResponse.body.Result);
            setUser(usuario);
            setLogged(true);
            let buyerTypeResponse = await new UserService().getBuyerType(
                cookieJWT.AccessToken
            );
            let buyerType = JSON.parse(buyerTypeResponse.Result);
            setBuyerType(buyerType);
            if (buyerType != null) {
                sethasTransportAvailable(buyerType == 2);
            }
            let userId = usuario.UserId;
            userId = userId.toString().replace(' ', '');
            cookies.set(Globals.COOKIES.JWT, cookieJWT, cookieOptions);
            cookies.set(Globals.COOKIES.USER, userId, cookieOptions);
            history.push(Globals.APPLICATION_PATH.HOME);
        } else {
            setLoading(false);
        }
    };

    function onSubmit() {
        if (validate() && passwordValidation()) {
            setLoading(true);
            UpdatePassword(PassworduserDatas);
        } else {
            alert('Contraseña inválida.');
        }
    }

    async function UpdatePassword(PassworduserDatas) {
        if (
            cookies != undefined &&
            cookies.get(Globals.COOKIES.JWT) != undefined
        ) {
            await new UserService()
                .UpdatePassword(
                    cookies.get(Globals.COOKIES.JWT),
                    PassworduserDatas
                )
                .then(res => {
                    if (res.Errors.length > 0) {
                        alert(res.Errors[0].Value.toString());
                    } else {
                        if (res?.Result) {
                            if (PassworduserDatas.IsResetPasswordEmail) {
                                redirectToHome(JSON.parse(res.Result));
                            }
                            alert('Contraseña actualizada correctamente');
                        } else {
                            alert('No se ha podido actualizar la contraseña');
                        }
                    }
                });
        }
        setLoading(false);
    }

    const passwordValidation = () => {
        var password = PassworduserDatas.NewPassword;
        return (
            utils.validateLength(password, 12, 20) &&
            utils.findLowerCase(password) &&
            utils.findUpperCase(password) &&
            utils.findNumbers(password) &&
            utils.findSpecialChars(password) &&
            !utils.findRepeat3(password)
        );
    };

    const validate = () => {
        let isValid = true;
        let errorss = {};
        if (!IsResetPasswordEmail) {
            if (PassworduserDatas.CurrentPassword !== '') {
                errorss.CurrentPasswordError = '';
            } else {
                errorss.CurrentPasswordError =
                    'Debes introducir su actual contraseña';
                isValid = false;
            }
        }
        if (
            PassworduserDatas.NewPassword ===
            PassworduserDatas.RepeatNewPassword
        ) {
            if (PassworduserDatas.NewPassword !== '') {
                errorss.NewPasswordError = '';
            } else {
                errorss.NewPasswordError =
                    'Debes introducir un nueva contraseña';
                isValid = false;
            }

            if (PassworduserDatas.RepeatNewPassword !== '') {
                errorss.RepeatNewPasswordError = '';
            } else {
                errorss.RepeatNewPasswordError =
                    'Debe introducir de nuevo la nueva contraseña';
                isValid = false;
            }
        } else {
            errorss.RepeatNewPasswordError =
                'La nueva contraseña  tiene que coincidir con la repetida';
            isValid = false;
        }

        setErrors(errorss);
        return isValid;
    };

    const printLayoutLayer = inputObject => {
        let inputComplete = [];
        const p = inputObject;
        if (!IsResetPasswordEmail) {
            inputComplete.push(
                <div className="o-layout" key={p}>
                    <div className="o-layout__item u-1/4 u-1/1@s">{p}</div>
                </div>
            );
        } else {
            inputComplete.push(p);
        }
        return inputComplete;
    };

    const printInputNewPassword = () => {
        let newPasswordInput = [];
        newPasswordInput.push(
            <Fragment key="new-password-input">
                <Input
                    options={optionsInputPassword}
                    onChange={e => onChange(e, optionsInputPassword.name)}
                    disableCopy
                    disablePaste
                    data-context="password"
                ></Input>
                <p className="c-error-message" id="NewPasswordError">
                    {errors.NewPasswordError}
                </p>
            </Fragment>
        );
        return newPasswordInput;
    };

    const printInputRepeatNewPassword = () => {
        let repeatPasswordInput = [];
        repeatPasswordInput.push(
            <Fragment key="repeat-password-input">
                <Input
                    options={optionsInputRepeatPassword}
                    onChange={e => onChange(e, optionsInputRepeatPassword.name)}
                    disableCopy
                    disablePaste
                    data-context="repeat-password"
                ></Input>
                <p className="c-error-message" id="RepeatNewPasswordError">
                    {errors.RepeatNewPasswordError}
                </p>
            </Fragment>
        );
        return repeatPasswordInput;
    };

    const printButtonSave = () => {
        let buttonSave = [];
        buttonSave.push(
            <Button
                key="reset-password-button"
                options={optionsBtn}
                onClick={onSubmit}
            ></Button>
        );
        return buttonSave;
    };

    const printToastNotification = () => {
        if (Object.keys(showToast).length == 0) return null;
        return (
            <ToastNotification
                options={showToast}
                closeToast={() => setShowToast({})}
            />
        );
    };

    const printHelpPasswordInfo = () => {
        delegate('#root', {
            target: '[data-tippy-content]',
            allowHTML: true,
            theme: 'light',
        });
        return (
            <Fragment>
                <button
                    type="button"
                    style={{ marginLeft: '10px' }}
                    className="c-icon c-info-icon js-tooltip c-icon--[semantic-info] c-info-icon-tooltip"
                    data-tippy-content="<p>Condiciones de contraseña:</p> <ul>
                    <li> Utilice entre 12 y 20 caracteres. Debe contener al menos un número, una letra en mayúscula, una en minúscula y un carácter especial </li>
                    <li> No puede tener 3 caracteres iguales seguidos</li>
                    </ul>"
                    data-tippy-placement="right"
                    tabIndex="-1"
                ></button>
            </Fragment>
        );
    };

    const printHelpPasswordInfoCambio = () => {
        delegate('#root', {
            target: '[data-tippy-content]',
            allowHTML: true,
            theme: 'light',
        });
        return (
            <Fragment>
                <button
                    type="button"
                    style={{ marginLeft: '10px' }}
                    className="c-icon c-info-icon js-tooltip c-icon--[semantic-info] c-info-icon-tooltip"
                    data-tippy-content="<p>Condiciones de contraseña:</p> <ul>
                    <li> Utilice entre 12 y 20 caracteres. Debe contener al menos un número, una letra en mayúscula, una en minúscula y un carácter especial</li>
                    <li> No puede tener 3 caracteres iguales seguidos ni 3 caracteres en el mismo orden que la contraseña actual </li>
                    </ul>"
                    data-tippy-placement="right"
                    tabIndex="-1"
                ></button>
            </Fragment>
        );
    };

    return (
        <Fragment>
            <div className="c-tabs__content  js-tabs__content u-mb-xlarge">
                <fieldset className="o-fieldset">
                    <legend className="c-form-heading  ">
                        <strong className="c-form-heading__title u-mb u-mt">
                            {t.getTraduction('PasswordTitle')}
                            {IsResetPasswordEmail
                                ? printHelpPasswordInfo()
                                : printHelpPasswordInfoCambio()}
                        </strong>
                    </legend>
                    {!IsResetPasswordEmail && (
                        <div className="o-fieldset__row">
                            <div className="o-layout">
                                <div className="o-layout__item u-1/4 u-1/1@s">
                                    <Input
                                        options={optionsInputActualPassword}
                                        onChange={e =>
                                            onChange(
                                                e,
                                                optionsInputActualPassword.name
                                            )
                                        }
                                        data-context="actual-password"
                                    ></Input>
                                    <p
                                        className="c-error-message"
                                        id="CurrentPasswordError"
                                    >
                                        {errors.CurrentPasswordError}
                                        {InitCurrentPasswordErrorBackend}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="o-fieldset__row">
                        {printLayoutLayer(printInputNewPassword())}
                    </div>
                    <div className="o-fieldset__row">
                        {printLayoutLayer(printInputRepeatNewPassword())}
                    </div>
                    <div className="o-fieldset__row">
                        {printLayoutLayer(printButtonSave())}
                    </div>
                </fieldset>
            </div>
            {printToastNotification()}
            <Loading ariaBusy={loading}></Loading>
        </Fragment>
    );
}
export default withCookies(PasswordModule);
